import i18n from 'src/i18n';

const configTable = () => {
  const tableColumns = [
    {
      prop: "name",
      label: i18n.t('common_words.name'),
      minWidth: 100
    },
    {
      prop: "code",
      label: i18n.t('common_words.code'),
      minWidth: 100
    },
    {
      prop: "description",
      label: i18n.t('common_words.description'),
      minWidth: 100
    },
  ];

  return { tableColumns };
}

export default configTable;
